import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from 'swipeclock-frontend';
import { useUser } from 'store/userSlice';
import { styled } from '@mui/material/styles';

export default function SignOutBar({ onLogout }) {
  const user = useUser();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      pb={2}
    >
      <Typography>Hi {user.employeeName}</Typography>
      <SignOutButton
        id="sc-sign_out_button"
        variant="outlined"
        onClick={onLogout}
      >
        Sign Out
      </SignOutButton>
    </Box>
  );
}

SignOutBar.propTypes = {
  onLogout: PropTypes.func,
};

/** styled components */

const SignOutButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.dark,
  borderColor: theme.palette.primary.dark,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
  },
}));
